import { render, staticRenderFns } from "./CrewProfile.vue?vue&type=template&id=40c50e21&scoped=true&"
import script from "./CrewProfile.vue?vue&type=script&lang=js&"
export * from "./CrewProfile.vue?vue&type=script&lang=js&"
import style0 from "./CrewProfile.vue?vue&type=style&index=0&id=40c50e21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c50e21",
  null
  
)

export default component.exports